module.exports = __webpack_public_path__ + "img/177943-89-4.ff3b9472.png";